export default __webpack_public_path__ + "static/media/coding.0f4e907f.svg";